import React from 'react';

const DiscordSection = () => {
  return (
    <section className="discord-invite">
      <div className="container">
        <div className="discord-content">
          <div className="discord-icon">
            <i className="fab fa-discord"></i>
          </div>
          <h2 className="discord-title">Rejoignez la Communauté <span className="highlight">SideLife</span></h2>
          <p className="discord-description">
            Découvrez le futur du RP FiveM avec notre communauté grandissante. 
            Échangez, participez et faites partie de l'aventure SideLife.
          </p>
          <a 
            href="https://discord.gg/ZQh79htaUf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-discord"
          >
            <i className="fab fa-discord"></i>
            Rejoindre le Discord
          </a>
        </div>
      </div>
    </section>
  );
};

export default DiscordSection;